<div class="filters d-flex flex-row">
  <div
    [ngClass]="{ active: !_filter }"
    (click)="filter()"
    class="action filter"
    *ngIf="all_label"
  >
    {{ all_label }}
  </div>
  <div class="v-break"></div>
  <div
    [ngClass]="{ active: blok.title === _filter }"
    (click)="filter(blok.title)"
    class="action filter"
    *ngFor="let blok of groups"
  >
    {{ blok.title }}
  </div>
</div>
<div [appStoryblok]="_editable" *ngFor="let blok of _filteredGroups || groups">
  <ndc-dynamic
    *ngIf="components"
    [ndcDynamicComponent]="components[blok.component]"
    [ndcDynamicInputs]="blok"
  >
  </ndc-dynamic>
</div>
